import { render, staticRenderFns } from "./BldrElement.vue?vue&type=template&id=206f7806"
import script from "./BldrElement.vue?vue&type=script&lang=js"
export * from "./BldrElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports